// import './App.css';
import All from "./components/All";
import PsdComp from "./components/PsdComp";
import ResponsiveComp from "./components/ResponsiveComp";
import ReactComp from "./components/ReactComp";
import NextComp from "./components/NextComp";
import MernComp from "./components/MernComp";
import PythonComp from "./components/PythonComp";
import "./index.css";
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import HeadButtons from "./components/HeadButtons";



// import './App.css';

function App() {
  return (
    <div className="workflow">


    <div className="container-fluid">
    <h1 class="text-center text-white">Portfolio</h1>
            <div class="design1 mx-auto"></div>
            <div class="design2 mx-auto"></div>
    </div>


    <div className="container mb-5">
       <a href="https://abirs-personal-portfolio.netlify.app/" className="backToHome"><i className="fas fa-arrow-left"></i> Go back to previous page.</a>
    </div>


    <Router>
        <HeadButtons/>
        <Switch>
          <Route exact path="/" component={All}/>
          <Route exact path="/psd" component={PsdComp}/>
          <Route exact path="/responsive" component={ResponsiveComp}/>
          <Route exact path="/react" component={ReactComp}/>
          <Route exact path="/next" component={NextComp}/>
          <Route exact path="/mern" component={MernComp}/>
          <Route exact path="/python" component={PythonComp}/>
        </Switch>
      </Router>

    </div>
  );
}

export default App;
